import script from "./LicensePlateEditOverlay.vue?vue&type=script&setup=true&lang=ts"
export * from "./LicensePlateEditOverlay.vue?vue&type=script&setup=true&lang=ts"

import "./LicensePlateEditOverlay.vue?vue&type=style&index=0&id=8e69a400&lang=sass&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e69a400"]])

export default __exports__